import { ProfileData, FormatType } from '../types';

// Simplified markdown utilities for direct markdown handling

export const profileToMarkdown = (profile: ProfileData, _format: FormatType): string => {
  // Simply return the current content
  return profile.content || '';
};

export const markdownToProfile = (
  markdown: string,
  format: FormatType,
  originalProfile: ProfileData
): ProfileData => {
  // Simply update the content in the profile
  return {
    ...originalProfile,
    content: markdown,
    isDirty: true
  };
};

// Validation functions
export const validateProfileMarkdown = (markdown: string, _format: FormatType): string[] => {
  const errors: string[] = [];
  
  // Basic validation - just check if markdown is not empty
  if (!markdown || markdown.trim().length === 0) {
    errors.push('Profile content cannot be empty');
  }
  
  return errors;
};

// Format switching utilities (simplified)
export const switchFormat = (
  profile: ProfileData,
  _fromFormat: FormatType,
  _toFormat: FormatType
): ProfileData => {
  // Since we're using markdown directly, just return the profile as-is
  return profile;
};

// Helper function to generate default values
export const generateDefaultProfile = (userId: string, name: string): ProfileData => {
  return {
    id: `profile-${userId}`,
    userId,
    name,
    title: '',
    location: '',
    content: '',  // Add the required content field
    summary: '',
    therapeuticAreas: [],
    disciplinaryFocus: []
  };
};

// Export format helpers
export const getFormatRequirements = (format: FormatType) => {
  switch (format) {
    case 'full':
      return {
        maxSummaryLength: 2000,
        maxTherapeuticAreas: 10,
        maxDisciplinaryFocus: 10,
        exportFormats: ['pdf']
      };
    case 'one-slider':
      return {
        maxSummaryLength: 500,
        maxTherapeuticAreas: 5,
        maxDisciplinaryFocus: 5,
        exportFormats: ['pptx']
      };
    case 'intro':
      return {
        maxSummaryLength: 150,
        maxBulletPoints: 3,
        exportFormats: ['pptx']
      };
    default:
      return {
        maxSummaryLength: 500,
        exportFormats: ['pptx', 'pdf']
      };
  }
};